import stylesheet from './SocialLinks.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTSocialLinks extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add('social-links');
        container.innerHTML = `<slot></slot>`;
        return container;
    }
}

customElements.define('nxt-social-links', NXTSocialLinks);
